import { FunctionComponent } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { IconName } from '@shinetools/sunshine-icons';

import { CompanyLegalBeneficiary } from '../../../../../../../../__generated__/GQL';
import SunshineIcon from '../../../../../../../../components/_core/SunshineIcon';
import Text from '../../../../../../../../components/_core/Text';
import type { CurrentBeneficiariesEmails } from '../../../../../../components/BeneficiaryForm/helpers';
import BeneficiaryCard from '../BeneficiaryCard';

interface BeneficiarySectionProps {
  title: string;
  description?: string;
  icon: IconName;
  beneficiaries: CompanyLegalBeneficiary[];
  currentBeneficiariesEmails: CurrentBeneficiariesEmails;
}
const BeneficiarySection: FunctionComponent<BeneficiarySectionProps> = ({
  beneficiaries,
  currentBeneficiariesEmails,
  description,
  icon,
  title,
}) => {
  if (!beneficiaries.length) {
    return null;
  }

  return (
    <Box marginBottom="space-32">
      <Flex alignItems="center" marginBottom="space-16">
        <SunshineIcon color="grey.700" marginRight="space-8" name={icon} />
        <Text>{title}</Text>
      </Flex>
      {description ? (
        <Text marginY="space-8" size="sm">
          {description}
        </Text>
      ) : null}
      <Box>
        {beneficiaries.map((beneficiary) => (
          <Box
            key={beneficiary.companyLegalBeneficiaryId}
            marginBottom="space-16"
          >
            <BeneficiaryCard
              beneficiary={beneficiary}
              currentBeneficiariesEmails={currentBeneficiariesEmails}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default BeneficiarySection;
